import {
  Grid
} from '@material-ui/core';
import Box from '@mui/material/Box';
import {  removeAccentsExcpetn } from '../../../helpers/RemoveAccents';
import { styleFind as style } from '../css/styleSheet';

const SearcherColaboradorEval = ({  
  setState,
  stateInitial,
  label = "Buscar colaborador ...",   
  width = 414,    
}:any) => {


  const handleChange = (e: any) => {
   const array=[...stateInitial]        
    if (e !== '') {           
            const nuevoFiltrado= array.filter((list:any) => {              
                return (    removeAccentsExcpetn(list.bussinesName.replace(/ /g, "").toLowerCase()).includes(removeAccentsExcpetn(e.replace(/ /g, "").toLowerCase()))
                          
                )
            })                         
           setState(nuevoFiltrado)
        }else{
         setState(stateInitial);            
       }               
    };     


    return (
      <Grid item>
          <Box >
              <Grid
                  container
                  direction="row"
                  style={{...style.containerSearcher, width: width}}
              >
                  <Grid item >
                      <input
                          style={{...style.inputSearcher, width: (width - 100)}}
                          className="collaboratorTab__searcher"
                           placeholder={label}
                           onChange={(e) => handleChange(e.target.value)}
                      />
                  </Grid>

                  <Grid item style={{
                      width: "20px",
                      padding: "0 20px 0 40px",
                      color: "#7f7f81",
                      fontStyle: "bold",
                  }}>
                      <img
                          src="/assets/icons/icono-buscar.svg"
                          alt="Buscar"
                      />
                  </Grid>

              </Grid>
          </Box>
      </Grid>

  )
}

export default SearcherColaboradorEval